import { c as _c } from "react/compiler-runtime";
import { SegmentGroup } from '@chakra-ui/react';
import React from 'react';

/** The small two- or four-way switch at the top right of a page: "What needs me / Everything", "7d / 30d". */
export function CrmSegmented(props) {
  const $ = _c(12);
  const t0 = props.size === "xs" ? "sm" : props.size || "sm";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      "--segment-indicator-bg": "{colors.colorPalette.subtle}",
      "--segment-indicator-shadow": "none",
      "& [data-state=checked]": {
        color: "{colors.colorPalette.fg}",
        fontWeight: "bold"
      },
      "& [data-state=unchecked]": {
        color: "{colors.fg.muted}"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== props) {
    t2 = event => {
      if (event.value) {
        props.onChange(event.value as T);
      }
    };
    $[1] = props;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SegmentGroup.Indicator />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props.items) {
    t4 = <SegmentGroup.Items items={props.items} />;
    $[4] = props.items;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props.ariaLabel || $[7] !== props.value || $[8] !== t0 || $[9] !== t2 || $[10] !== t4) {
    t5 = <SegmentGroup.Root aria-label={props.ariaLabel} bg="gray.panel" borderColor="gray.border" borderWidth="1px" boxShadow="none" colorPalette="orange" size={t0} value={props.value} css={t1} onValueChange={t2}>{t3}{t4}</SegmentGroup.Root>;
    $[6] = props.ariaLabel;
    $[7] = props.value;
    $[8] = t0;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}